import { Component, Inject, Vue } from "vue-property-decorator";
import DashboardPreview from "../DashboardTemplate/components/Preview/DashboardPreview.vue";
import { BqDashboardService } from "../DashboardTemplate/services/BqDashboardService";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { Http } from "@status/codes";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DashboardTemplateResponse } from "../DashboardTemplate/models/DashboardTemplateResponse";

@Component({
  name: "Dashboard",
  components: { DashboardPreview, DynamicSelect }
})
export default class Dashboard extends Vue {
  @Inject() bqDashboardService!: BqDashboardService;

  template = [] as DynamicSelectData[];
  templateOptionsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "Seleccionar plantilla",
    hideDetails: false,
    attach: false,
    limit: 3,
    required: true
  };
  dashboardTemplate: DashboardTemplateResponse = new DashboardTemplateResponse();
  loading = false;

  mounted() {
    this.getAllTemplates();
  }

  async getAllTemplates() {
    const response = await this.bqDashboardService.getAllTemplates();
    if (response.code == Http.Found) {
      this.templateOptionsConfig.listAll = (response.data as unknown) as DynamicSelectData[];
    }
  }
  async onTemplateChange() {
    this.loading = true;
    const templateResponse = await this.bqDashboardService.getTemplateById(
      this.template[0].id
    );
    this.loading = false;
    if (templateResponse.code == Http.Found) {
      this.dashboardTemplate = templateResponse.data;
    }
  }
}
